import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ReviewStepDetails', {
    reassignReviewerTitleText: 'Reassign the request to another Reviewer',
    editReviewerTitleText: 'Change the Reviewer in this step',
    skippedText: 'There are no Reviewers in this step.{br}It has been skipped.',
});
